import { render, staticRenderFns } from "./SendAudio.vue?vue&type=template&id=35a33c2c"
import script from "./SendAudio.vue?vue&type=script&lang=js"
export * from "./SendAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports